import React, { Fragment, useMemo } from "react";
import { ReferenceInput, SelectInput } from "ra-ui-materialui";

import { get } from "lodash";
import { useFormState } from "react-final-form";

const SelectInputWrapper = ({ choices, ...props }) => {
  const formState = useFormState();
  const selectedId = get(formState.values, "technical_report_group_id");
  const helpText = useMemo(
    () =>
      get(
        choices.find((c) => c.id === selectedId),
        "help_text",
        null
      ),
    [selectedId, choices]
  );
  return (
    <Fragment>
      <SelectInput {...props} choices={choices} />
      <div dangerouslySetInnerHTML={{ __html: helpText }} />
    </Fragment>
  );
};

const TechnicalReportGroupInput = ({ ...props }) => {
  return (
    <ReferenceInput {...props} reference="technical-report-groups">
      <SelectInputWrapper source="name" />
    </ReferenceInput>
  );
};
export default TechnicalReportGroupInput;
